var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('map-tool',{attrs:{"tools":['weixin'],"grid":false},on:{"on-select":_vm.selectTool}}),_c('div',{attrs:{"id":"area-container"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }